inputs-complex-delivery-other-attachments
  div(class="form-group row {error: opts.errors}")
    label.col-md-4.col-form-label
      | {opts.label}
    .col-md-8
      label.col-form-label(style="font-size: 1rem")
        | {opts.label1}
      input(type="hidden" value="{opts.value}" name="{opts.name}" style="width: 100%" class="form-control")
      div.wrap(each="{item, index in items}" class="{(item.value == '1') ? 'checked' : ''}")
        .d-flex
          span.checkbox
            input(if="{item.checked}" type="checkbox" checked="checked" onchange="{onChangeCheckbox}")
            input(if="{!item.checked}" type="checkbox" onchange="{onChangeCheckbox}")
          span.num {item.label}
          span.radio-wrap
            input(if="{ item.inclusion }" name="{this.tagScope}_{index}_inclusion" value="1" checked="checked" id="{this.tagScope}_{index}_inclusion" type="radio" onClick="{ onChangeInclusion }")
            input(if="{ !item.inclusion }" name="{this.tagScope}_{index}_inclusion" value="1" id="{this.tagScope}_{index}_inclusion" type="radio" onClick="{ onChangeInclusion }")
            label(for="{this.tagScope}_{index}_inclusion") 同梱
            input(if="{ !item.inclusion }" name="{this.tagScope}_{index}_inclusion" value="0" checked="checked" id="{this.tagScope}_{index}_separate" type="radio" onClick="{ onChangeInclusion }")
            input(if="{ item.inclusion }" name="{this.tagScope}_{index}_inclusion" value="0" id="{this.tagScope}_{index}_separate" type="radio" onClick="{ onChangeInclusion }")
            label(for="{this.tagScope}_{index}_separate") 別送
          input.filename.form-control(type="text" value="{item.value}" onBlur="{onChangeText}")
      label.col-form-label(style="font-size: 1rem")
        | {opts.memo_for_delivery.label}
      inputs-without-label-textarea(tag-scope="{this.tagScope}.memo_for_delivery")
  script(type="typescript").
    this.mixin('inputs.complex.delivery-other-attachments')
  style(scoped).
    .num {
      margin: .4rem .5rem 0 .5rem;
    }
    .checkbox {
      margin: .4rem 0 0 0;
    }
    .filename {
      width: 25rem;
    }
    .radio-wrap {
      margin: .4rem 0 0 0;
      padding: 0 1rem 0 .5rem;
    }
